import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");

  const navigate = useNavigate();

  const handleLogin = () => {
    if (user === "admin" && pass === "1234") {
      localStorage.setItem("isAdmin", "true");
      navigate("/admin");
    } else {
      alert("Wrong credentials");
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>

      {/* 🔙 BACK BUTTON */}
      <button
        className="btn"
        style={{ position: "absolute", left: "20px", top: "100px" }}
        onClick={() => navigate("/")}
      >
        ⬅ Back to Home
      </button>

      <h2>🔐 Admin Login</h2>

      <input 
        placeholder="Username"
        value={user}
        onChange={(e) => setUser(e.target.value)}
      /><br/><br/>

      <input 
        type="password"
        placeholder="Password"
        value={pass}
        onChange={(e) => setPass(e.target.value)}
      /><br/><br/>

      <button className="btn" onClick={handleLogin}>
        Login
      </button>
    </div>
  );
};

export default Login;